export default {
   intro: ``,
   footer: '[[ {"a":{"href":"https://sjr-fuerth.de/impressum/", "title":"Impressum ansehen", "target":"_blank"}} ]]Impressum[[ /a ]] | [[ {"a":{"href":"https://sjr-fuerth.de/datenschutz/", "title":"Datenschutz ansehen", "target":"_blank"}} ]]Datenschutz[[ /a ]]',
   approvals: [
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://sjr-fuerth.de/datenschutz/", "title":"Datenschutz ansehen", "target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.'
   ]
};